import { TThunkAction } from '../../types/redux';
import { trackCalculateClick } from './tracking';
import { getFiltersQs } from './getFiltersQs';
import { navigateToPage } from '../../utils/navigateToPage';

export const submitValuationForm = (): TThunkAction => (dispatch, getState) => {
  const state = getState();
  const { filters, page } = state;
  const { address, roomsCount, area } = filters;

  const queryString = getFiltersQs(filters);

  trackCalculateClick({
    page,
    queryString,
    address,
    area,
    roomsCount,
  });

  navigateToPage(`/kalkulator-nedvizhimosti/?${queryString}`);
};
